import FilterCareer from "../Components/CareersComponents/FilterCareer";
import "../styles/Careers.css";

function Careers() {
   // ################### Global Data ###################
   document.title = "ماتريكس | وظائف";

   return (
      <div className="carrers">
         <div className="model-overlay"></div>
         <FilterCareer />
      </div>
   );
}

export default Careers;
